module.exports = __webpack_public_path__ + "destaque.jpg?a3cae7cc89d184f26d4fa61230f0bdf8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/destaque.jpg
// module id = 111
// module chunks = 0